import * as Sentry from '@sentry/react';
import { useAuthStore } from '../store/authStore';

const ignoredErrorPatterns: RegExp[] = [
  /ResizeObserver loop/i,
  /Non-Error promise rejection captured/i,
  /Load failed/i,
  /Failed to fetch/i,
  /NetworkError when attempting to fetch/i,
  /The operation was aborted/i,
  /chrome-extension:\/\//i,
  /moz-extension:\/\//i,
  /safari-extension:\/\//i,
];

export function initializeSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  const environment = import.meta.env.MODE === 'production' ? 'production' : 'development';

  Sentry.init({
    dsn,
    environment,
    release: import.meta.env.VITE_SENTRY_RELEASE,

    // Route events through our backend to bypass ad blockers that block ingest.sentry.io.
    // See services/web/backend/src/api/routes/sentry-tunnel.ts.
    tunnel: '/api/v1/sentry-tunnel',

    integrations: [Sentry.browserTracingIntegration()],

    tracesSampleRate: environment === 'production' ? 0.05 : 1.0,

    ignoreErrors: ignoredErrorPatterns,
    denyUrls: [/chrome-extension:\/\//, /moz-extension:\/\//, /safari-extension:\/\//],

    beforeSend(event) {
      if (event.request?.headers) {
        delete (event.request.headers as Record<string, string>)['authorization'];
        delete (event.request.headers as Record<string, string>)['cookie'];
      }
      return event;
    },
  });

  const syncUser = (address: string | null) => {
    if (address) {
      Sentry.setUser({ id: address, username: address });
    } else {
      Sentry.setUser(null);
    }
  };
  syncUser(useAuthStore.getState().activeWalletAddress);
  useAuthStore.subscribe((state, prev) => {
    if (state.activeWalletAddress !== prev.activeWalletAddress) {
      syncUser(state.activeWalletAddress);
    }
  });
}

export { Sentry };
